<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HPFsMm/tc-custom/9781638293026.jpg?1718282809176" alt="This image is the cover for the book Everybody Needs Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Everybody Needs Love
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;color:black;background:white;'>“Eddie was a black man in a white man's body. No one I've ever worked with or heard had any more Soul than Eddie did. His guitar playing was always tasteful, strong and distinctive...his voice grabbed you and pulled you in so that you not only heard it, but you felt it...and were mesmerized by it. He had a beautiful smile... but behind it were some inner thoughts that had to do with some deep pain that he kept hidden inside. That was one of the things that made him so intriguing, so interesting and so powerful.”</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;color:black;background:white;'>– Chuck Leavell, piano player for the Rolling Stones and the Allman Brothers Band, among many others.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce Schurman
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>Born in Wolfville, Nova Scotia, Canada, Bruce has been a lover of music his whole life. A drummer in his younger years, he played full time into his late twenties when, having started a family, he began working for UPS. After his retirement, he discovered Eddie Hinton&rsquo;s music and began researching Eddie&rsquo;s life. Finding scarce information and wanting more, he ventured south to Muscle Shoals, Alabama, interviewing Eddie&rsquo;s mother, friends, and colleagues. This book is the result of that journey.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cc2bba8